import React, { memo } from 'react'
import Image from 'next/image'
import Box from '@mui/material/Box'
import sx from './styles'

const ResponsiveImage = ({
  image, ...props
}) => {
  return (
    <Box sx={sx.imageContainer}>
      <Image
        style={{ width: 500, height: '100%!important' }}
        width={300}
        height={600}
        className="img"
        src={image.url}
        alt={image?.alt || image?.title}
        title={image.title}
        {...props}
      />
    </Box>
  )
}

export default memo(ResponsiveImage)
